import { render, staticRenderFns } from "./Cinema.vue?vue&type=template&id=55f5f548&scoped=true&"
import script from "./Cinema.vue?vue&type=script&lang=js&"
export * from "./Cinema.vue?vue&type=script&lang=js&"
import style0 from "./Cinema.vue?vue&type=style&index=0&id=55f5f548&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f5f548",
  null
  
)

export default component.exports